import React from 'react';
import { Moon, Sun, Clock } from 'lucide-react';
import FlatDashboardCard from '@/components/ui/FlatDashboardCard';
import CardHeader from '@/components/ui/CardHeader';
import ActionButton from '@/components/ui/ActionButton';
import { useTheme } from '@/hooks/layout/use-theme';
import { useToast } from '@/hooks/errors/use-toast';

const ThemeSection = () => {
  const { theme, setTheme } = useTheme();
  const { toast } = useToast();

  const handleTimeSyncClick = () => {
    setTheme('time-sync');
    
    // Show toast notification
    const currentHour = new Date().getHours();
    const isCurrentlyLight = currentHour >= 6 && currentHour < 18;
    const nextMode = isCurrentlyLight ? 'dark' : 'light';
    const nextSwitchTime = isCurrentlyLight ? '6PM' : '6AM';
    
    toast({
      title: "Time Sync Activated",
      description: `Currently ${isCurrentlyLight ? 'light' : 'dark'} mode. We'll switch you to ${nextMode} at ${nextSwitchTime}.`,
      duration: 3000,
    });
  };

  return (
    <FlatDashboardCard>
      <CardHeader
        title="Theme Settings"
        icon={Moon}
        variant="purple"
        className="mb-6"
      />
      
      <div className="space-y-6">
        <div>
          <div className="flex flex-wrap gap-3">
            <ActionButton 
              variant={theme === 'light' ? 'vibrant' : 'default'}
              icon={<Sun size={16} />}
              onClick={() => setTheme('light')}
              className={`
                ${theme === 'light' ? 'bg-gradient-to-br from-yellow-200 to-yellow-300 text-gray-700 shadow-md hover:opacity-90 border border-yellow-400/30' : ''}
              `}
            >
              Light
            </ActionButton>
            <ActionButton 
              variant={theme === 'dark' ? 'vibrant' : 'default'}
              icon={<Moon size={16} />}
              onClick={() => setTheme('dark')}
              className={`
                ${theme === 'dark' ? 'bg-gradient-to-br from-[var(--brand-purple-gradient-dark-mode-from)] to-[var(--brand-purple-gradient-dark-mode-to)] text-white hover:opacity-90' : ''}
              `}
            >
              Dark
            </ActionButton>
            <ActionButton 
              variant={theme === 'time-sync' ? 'vibrant' : 'default'}
              icon={<Clock size={16} />}
              onClick={handleTimeSyncClick}
              className={`
                ${theme === 'time-sync' ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-md hover:opacity-90 border border-blue-400/30' : ''}
              `}
            >
              Time Sync
            </ActionButton>
          </div>
        </div>
      </div>
    </FlatDashboardCard>
  );
};

export default ThemeSection; 